import { Link } from "react-router-dom";

const LoginRedirect = () => {

    return ( 
        
        <div className="container body-content" style={{marginTop: "25px"}}>
            <h3>Please sign in to view this Page.</h3>
            <Link to="/Login" className="btn btn-primary" style={{marginRight: "4px", paddingLeft: "32px", paddingRight: "32px"}}>OK</Link>
            
        </div>
     );
}
 
export default LoginRedirect;